export default {
  error: {
    onlineCheck: '当前登录人数超过上限，请稍后重试。',
  },
}
